import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=8c371bf0&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Product.vue?vue&type=style&index=1&id=8c371bf0&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c371bf0",
  null
  
)

export default component.exports